module.exports = __webpack_public_path__ + "assets/images/bfcec35590cd30bf127d33ef2e6e6ed1.png";